import { Component, ElementRef, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { PageBase } from 't4core';
import { FindBookingDialog } from '../../../../t4common';



@Component({
    styleUrls: ['./home.css'],
    selector: 'home',
    templateUrl: './home.component.html',
})
export class HomeComponent extends PageBase implements OnInit {
    private _fromDate: Moment = moment().startOf('month');
    private _toDate: Moment = moment().endOf('month');

    public get fromDate(): Moment { return this._fromDate; }
    public set fromDate(value: Moment) { this._fromDate = value; }

    public get toDate(): Moment { return this._toDate; }
    public set toDate(value: Moment) { this._toDate = value; }

    constructor(el: ElementRef) {
        super(el, "Bookings");

    }

    public async ngOnInit() { }

    public async loadData() {
      //Trigger ngOnChanges on child components
      this.fromDate = this.fromDate.clone();
  }

  public findBooking() {
    var dlg = this.Dialog.open(FindBookingDialog, {});
  }
}
